module.exports = __webpack_public_path__ + "img/application-dashboard.0d29c776.svg";